// extracted by mini-css-extract-plugin
export default {"container":"dfa-z","heading":"efa-z","links":"ffa-z","linkBtn":"gfa-z","disabled":"hfa-z","linkUppercaseBold":"ifa-z","copy":"jfa-z","subCopy":"kfa-z"};